import React from 'react';
import { Search } from 'lucide-react';

interface LeaderboardSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function LeaderboardSearch({ value, onChange }: LeaderboardSearchProps) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search champions..."
        className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-amber-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 text-amber-100"
      />
    </div>
  );
}